module.exports = __webpack_public_path__ + "static/img/cflygram-kaka.1acde6b3.svg";